module.exports = __webpack_public_path__ + "img/ren.a7e80f71.svg";